import { Eye, LogOut } from "lucide-react";
import { toast } from "sonner";

import { useAuth } from "@/contexts/auth-context";
import { useStopImpersonation } from "@/hooks/security/use-impersonation";

/**
 * Barra que avisa que se está a ver a app como outra pessoa.
 *
 * Deliberadamente impossível de ignorar: sem ela, era fácil esquecer e pensar
 * que se está na própria conta — e depois estranhar que "não se consegue gravar
 * nada" (a sessão é só-leitura).
 */
export const ImpersonationBanner = () => {
  const { user } = useAuth();
  const stop = useStopImpersonation();

  if (!user?.impersonated_by) return null;

  const sair = async () => {
    try {
      await stop.mutateAsync();
    } catch {
      toast.error("Não foi possível voltar à tua conta");
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-2 text-sm text-amber-950">
      <Eye className="h-4 w-4 shrink-0" />
      <p>
        Estás a ver a app como <strong>{user.name}</strong>. Não podes alterar nada.
      </p>
      <button
        type="button"
        onClick={sair}
        disabled={stop.isPending}
        className="inline-flex items-center gap-1.5 rounded-md bg-amber-950/10 px-2.5 py-1 font-medium transition-colors hover:bg-amber-950/20 disabled:opacity-50"
      >
        <LogOut className="h-3.5 w-3.5" />
        {stop.isPending ? "A sair..." : "Voltar à minha conta"}
      </button>
    </div>
  );
};
